import React from 'react';
import { FadeIn } from './Shared';
import { Scale } from 'lucide-react';
export const CostComparison = () => {
  return <section className="py-8 md:py-12 px-4 bg-navy-900" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <FadeIn data-id="element-44">
          <div className="text-center mb-8" data-id="element-45">
            <h2 className="text-xl md:text-3xl font-serif font-bold text-white flex items-center justify-center" data-id="element-46">
              <Scale className="w-8 h-8 text-gold-400 mr-4" data-id="element-47" />
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-navy-800 rounded-2xl border border-navy-700 overflow-hidden shadow-2xl" data-id="element-48">
            <div className="overflow-x-auto" data-id="element-49">
              <table className="w-full text-left border-collapse" data-id="element-50">
                <thead data-id="element-51">
                  <tr className="bg-navy-900 border-b border-navy-700" data-id="element-52">
                    <th className="py-5 px-6 text-red-400 font-bold text-lg w-1/2 border-r border-navy-700" data-id="element-53">
                      Sin MegaPack
                    </th>
                    <th className="py-5 px-6 text-gold-400 font-bold text-lg w-1/2" data-id="element-54">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-navy-700/50" data-id="element-55">
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-56">
                    <td className="py-4 px-6 text-gray-300 border-r border-navy-700" data-id="element-57">
                      Buscar en Google cada semana
                    </td>
                    <td className="py-4 px-6 text-gray-400" data-id="element-58">
                      150 horas perdidas por año
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-59">
                    <td className="py-4 px-6 text-gray-300 border-r border-navy-700" data-id="element-60">
                      Rutinas que fallan el 50% de las noches
                    </td>
                    <td className="py-4 px-6 text-gray-400" data-id="element-61">
                      Agotamiento crónico
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-62">
                    <td className="py-4 px-6 text-gray-300 border-r border-navy-700" data-id="element-63">
                      Crisis sin protocolo a las 3 AM
                    </td>
                    <td className="py-4 px-6 text-gray-400" data-id="element-64">
                      Estrés que se acumula
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-65">
                    <td className="py-4 px-6 text-gray-300 border-r border-navy-700" data-id="element-66">
                      Sin entender las ventanas de sueño
                    </td>
                    <td className="py-4 px-6 text-gray-400" data-id="element-67">
                      Bebé sobreestimulado
                    </td>
                  </tr>
                </tbody>
                <tfoot data-id="element-68">
                  <tr className="bg-navy-900/80 border-t-2 border-gold-500/30" data-id="element-69">
                    <td colSpan={2} className="py-8 px-6 text-center" data-id="element-70">
                      <span className="text-2xl font-serif font-bold text-white" data-id="element-71">
                        La próxima madrugada{' '}
                        <span className="text-gold-400 italic" data-id="element-72">
                          Puede ser diferente
                        </span>
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};